import { checkArray } from '@/generic-function.helper';
import { ITopicMessage } from '@/interfaces/topic-messages.interface';

const mutations = {
  SET_MY_TOPICS(state: any, payload: any) {
    state.myTopics = checkArray(payload);
  },

  SET_LATEST_TOPICS(state: any, payload: any) {
    state.latestTopics = checkArray(payload);
  },
  
  SET_MY_LATEST_TOPICS(state: any, payload: any) {
    state.myLatestTopics = checkArray(payload);
  },

  SET_LATEST_CATEGORY_TOPICS(state: any, payload: any) {
    state.latestCategoryTopics = checkArray(payload);
  },

  SET_MY_CATEGORY_TOPICS(state: any, payload: any) {
    state.myCategoryTopics = checkArray(payload);
  },

  SET_ACTIVE_TOPIC(state: any, payload: any) {
    state.activeTopic = payload;
  },

  SET_TOPICS(state: any, payload: any[]) {
    state.topics = checkArray(payload);
  },

  SET_REPORTING_TOPIC_MESSAGE(state: any, payload: ITopicMessage) {
    state.reportingTopicMessage = Object.assign({}, payload);
  }
};

export default mutations;
